import React, { useState, useEffect, useRef, Component, createRef } from 'react';
import './Nav.css';

import { NavLink, useLocation } from 'react-router-dom';

import en from '../../language/en/Nav.json';
import es from '../../language/es/Nav.json';
import { NativeSelect, FormControl, Select, MenuItem, makeStyles, withStyles, SwipeableDrawer, Collapse, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
		float: 'right',
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	selectLang: {
		color: theme.palette.common.white,
		'&:before': {
			borderBottomColor: theme.palette.common.white,
		},
		'& .MuiSelect-icon': {
			color: '#ffffff8a'
		}
	},
}));

const StyledMenuItem = withStyles((theme) => ({
	root: {
		'&:focus': {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.common.white,
			'& .MuiListItemIcon-root, & .MuiListItem-button': {
				color: theme.palette.common.white,
			},
		},
		'&:hover': {
			backgroundColor: theme.palette.common.white,
			color: theme.palette.secondary.main
		},
	},
}))(MenuItem);

const Nav = ({ onChange }) => {
	// Para la seleccion del idioma
	const classes = useStyles();

	const [config, setConfig] = useState({ lang: { en, es } });
	const [selectedLanguage, setSelectedLanguage] = useState('es');
	const [subMenuOpen, setSubMenuOpen] = useState([]);
	const [subMenuWeather, setSubMenuWeather] = useState('');
	const [subMenuForecast, setSubMenuForecast] = useState('');
	const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
	const headerRef = useRef(null);
	const location = useLocation();
	// const [sliderShow, setSliderShow] = useState(location.pathname === '/home');
	const [openSN, setOpenSN] = useState(false);

	// for the sideNav
	const [openCollapseQS, setOpenCollapseQS] = useState(false);
	const [openCollapseQH, setOpenCollapseQH] = useState(false);
	const [openCollapseI, setOpenCollapseI] = useState(false);

	// handle scroll event
	const handleScroll = (elTopOffset, elHeight) => {
		if (window.pageYOffset > (elTopOffset + elHeight)) {
			setSticky({ isSticky: true, offset: elHeight });
		} else {
			setSticky({ isSticky: false, offset: 0 });
		}
	};

	// add/remove scroll event listener
	useEffect(() => {
		var header = headerRef.current.getBoundingClientRect();
		const handleScrollEvent = () => {
			// console.log('header.top: ' + header.top);
			// console.log('header.height: ' + header.height);
			// console.log('window.innerHeight: ' + window.innerHeight);
			// console.log('window.pageYOffset: ' + window.pageYOffset);
			handleScroll(header.top, header.height)
		}

		window.addEventListener('scroll', handleScrollEvent);

		return () => {
			window.removeEventListener('scroll', handleScrollEvent);
		};
	}, [location.pathname === '/home']);

	useEffect(() => {
		const lang = config.lang;
		const options = (selectedLanguage === 'en') ? lang.en.menuOptions : lang.es.menuOptions;

		let index = 0, subMenuOpen = [];
		options.forEach(option => {
			subMenuOpen[index] = '';
			index++;

			if (option.submenu) {
				// cantSubMenus++;
			}

		});
		setSubMenuOpen(subMenuOpen);
	}, [])

	function changeLanguage(e) {
		e.preventDefault();
		setSelectedLanguage(e.target.value);
		onChange(e.target.value);
	}

	function dropdownMenu(menu) {
		//console.log('function dropdownMenu', 'data-toggle');

		const menuOptions = menu.map((option, i) => {
			const subMenu = option.submenu ? dropdownMenu(option.submenu) : "";

			let open = '';
			let genericOpenSubMenuFunc = () => { };
			let genericCloseSubMenuFunc = () => { };
			if (option.link === 'w') {
				open = subMenuWeather
				genericOpenSubMenuFunc = () => openSubMenuWeather;
				genericCloseSubMenuFunc = () => closeSubMenuWeather;
			} else if (option.link === 'wf') {
				open = subMenuForecast;
				genericOpenSubMenuFunc = () => openSubMenuForecast;
				genericCloseSubMenuFunc = () => closeSubMenuForecast;
			}

			return (
				<li key={i} className={option.submenu ? "dropdown-submenu" + open : "page-scroll"} onMouseLeave={option.submenu ? () => genericCloseSubMenuFunc() : () => { }}>
					<NavLink to={option.link} activeStyle={{ backgroundColor: '#ffffff26', borderTop: '3px solid #fff5', borderBottom: '3px solid #fff5' }} className={option.submenu ? "dropdown-toggle" : ""} data-toggle={option.submenu ? "dropdown" : ""} onMouseOver={option.submenu ? () => genericOpenSubMenuFunc() : () => { }}>
						{option.text}
					</NavLink>
					{subMenu}
				</li>
			)
		});

		return (
			<ul className="dropdown-menu" key="ulDropDown">
				{menuOptions}
			</ul>
		);
	}

	function dropdownSideMenu(menu) {
		//console.log('function dropdownMenu', 'data-toggle');

		const menuOptions = menu.map((option, i) => {
			const subMenu = option.submenu ? dropdownSideMenu(option.submenu) : "";

			let open = '';
			let genericOpenSubMenuFunc = () => { };
			let genericCloseSubMenuFunc = () => { };
			if (option.link === 'w') {
				open = subMenuWeather
				genericOpenSubMenuFunc = () => openSubMenuWeather;
				genericCloseSubMenuFunc = () => closeSubMenuWeather;
			} else if (option.link === 'wf') {
				open = subMenuForecast;
				genericOpenSubMenuFunc = () => openSubMenuForecast;
				genericCloseSubMenuFunc = () => closeSubMenuForecast;
			}

			return (
				<li key={i} className={option.submenu ? "dropdown-submenu" + open : "page-scroll"} onMouseLeave={option.submenu ? () => genericCloseSubMenuFunc() : () => { }} style={{ listStyle: 'none', padding: '7px 0' }}>
					{
						option.submenu ?
							<a href={option.link} className="dropdown-toggle" data-toggle="dropdown" onMouseOver={() => genericOpenSubMenuFunc()} onClick={() => { }} style={{ fontSize: '1.3rem', color: '#333' }}>
								{option.text}
							</a>
							:
							<NavLink to={option.link} activeStyle={{ backgroundColor: '#ffffff26', borderTop: '3px solid #fff5', borderBottom: '3px solid #fff5' }} className={option.submenu ? "dropdown-toggle" : ""} data-toggle={option.submenu ? "dropdown" : ""} onMouseOver={option.submenu ? () => genericOpenSubMenuFunc() : () => { }} onClick={() => setOpenSN(false)} style={{ fontSize: '1.3rem' }}>
								{option.text}
							</NavLink>
					}
					{subMenu}
				</li>
			)
		});

		return (
			<ul className="dropdown1-menu" key="ulDropDown">
				{menuOptions}
			</ul>
		);
	}

	function closeSubMenu(e, i) {
		const newSM = subMenuOpen.map((item, pos) => {
			if (i === pos) {
				return '';
			}
		});
		setSubMenuOpen(newSM);
	}

	function openSubMenu(e, i) {
		// this.setState({ subMenuOpen: [...this.state.subMenuOpen, this.state.subMenuOpen[i] = ' open'] })
		// console.log('Se llamó openSubMenu con i == ', i);

		const newSM = subMenuOpen.map((item, pos) => {
			if (i === pos) {
				return ' open';
			} else {
				return '';
			}
		});
		// console.log('newSM', newSM);
		setSubMenuOpen(newSM);
	}

	function openSubMenuWeather() {
		setSubMenuWeather(' open');
	}

	function closeSubMenuWeather() {
		setSubMenuWeather('');
	}

	function openSubMenuForecast() {
		setSubMenuForecast(' open');
	}

	function closeSubMenuForecast() {
		setSubMenuForecast('');
	}

	const lang = config.lang;
	const options = (selectedLanguage === 'en') ? lang.en.menuOptions : lang.es.menuOptions;


	const menu = options.map((option, i) => {
		const subMenu1 = option.submenu ? dropdownMenu(option.submenu) : "";
		const link = location.pathname !== '/' ? option.link : option.link;
		// console.log(i)
		return (
			<li key={i} className={option.submenu ? "dropdown" + subMenuOpen[i] : "page-scroll"} /* onClick={ this.setActiveSection.bind(this, option) } */ onMouseLeave={option.submenu ? (e) => closeSubMenu(e, i) : () => { }} >
				{
					option.target ?
						(
							<a href={link} target={option.target}>
								{option.text}
							</a>
						) :
						(
							<NavLink className={option.submenu ? "dropdown-toggle" : ""} data-toggle={option.submenu ? "dropdown" : ""} to={link} activeStyle={{ backgroundColor: '#fff3', border: '3px solid #fff5', borderRadius: '10px' }} onMouseOver={option.submenu ? (e) => openSubMenu(e, i) : () => { }}>
								{option.text}
							</NavLink>
						)
				}
				{option.submenu ? subMenu1 : ''}
			</li>
		)
	});

	const sideMenu = options.map((option, i) => {
		const subMenu1 = option.submenu ? dropdownSideMenu(option.submenu) : "";
		const link = location.pathname !== '/' ? option.link : option.link;
		// console.log(i)

		let setOpenCollapseFunc = () => { };
		let openCollapseFlag;
		switch (option.link) {
			case 'quienes-somos':
				setOpenCollapseFunc = () => {
					setOpenCollapseQS(!openCollapseQS);
					setOpenCollapseQH(false);
					setOpenCollapseI(false);
				}
				openCollapseFlag = openCollapseQS;
				break;
			case 'que-hacemos':
				setOpenCollapseFunc = () => {
					setOpenCollapseQS(false);
					setOpenCollapseQH(!openCollapseQH);
					setOpenCollapseI(false);
				}
				openCollapseFlag = openCollapseQH;
				break;
			case 'investigacion':
				setOpenCollapseFunc = () => {
					setOpenCollapseQS(false);
					setOpenCollapseQH(false);
					setOpenCollapseI(!openCollapseI);
				}
				openCollapseFlag = openCollapseI;
				break;

			default:
				break;
		}
		return (
			<li key={i} style={{ listStyle: 'none' }}>
				{
					option.target ?
						(
							<a href={link} target={option.target} style={{ fontSize: '1.5rem' }}>
								{option.text}
							</a>
						) :
						(option.link === '/home' || option.link === '/news' || option.link === '/api/doc' ?
							<NavLink to={link} activeStyle={{ backgroundColor: '#fff3', border: '3px solid #fff5', borderRadius: '10px' }} style={{ fontSize: '1.5rem' }} onClick={() => setOpenSN(false)}>
								{option.text}
							</NavLink>
							:
							<a onClick={setOpenCollapseFunc} style={{ color: '#757575', fontSize: '1.5rem', cursor: 'pointer' }} href>
								{option.text}
							</a>
						)
				}
				<Collapse in={openCollapseFlag} timeout="auto" unmountOnExit>
					{option.submenu ? subMenu1 : ''}
				</Collapse>
			</li>
		)
	});

	return (
		<div className="Nav" style={{ marginTop: sticky.offset }} >
			{/* <div className="background-sky hero"></div> */}

			<header id='header' className={`page-header${sticky.isSticky ? ' sticky' : ' sticky'}`} ref={headerRef}>

				<nav className="navbar" role="navigation">
					<div className="container">

						<FormControl className="language" className={classes.formControl}>
							<Select
								id="select"
								onChange={e => changeLanguage(e)}
								color="secondary"
								value={selectedLanguage}
								className={classes.selectLang}
							>
								<StyledMenuItem value="es">Español</StyledMenuItem>
								<StyledMenuItem value="en">English</StyledMenuItem>
							</Select>
						</FormControl>

						<div className="navbar-header page-scroll">
							<button type="button" className="navbar-toggle" data-toggle="/* collapse */" data-target=".navbar-responsive-collapse" onClick={() => setOpenSN(!openSN)} style={{ float: 'left' }}>
								<span className="sr-only">Toggle navigation</span>
								<span className="toggle-icon">
									<span className="icon-bar"></span>
									<span className="icon-bar"></span>
									<span className="icon-bar"></span>
								</span>
							</button>
							<a className="navbar-brand" href="./">
								<img src="./assets/admin/layout/img/logo_scroll_2.png" alt="logo" className="logo-default" />
								<img src="./assets/admin/layout/img/logo_scroll_2.png" alt="logo" className="logo-scroll" />
							</a>
						</div>

						<div className="collapse navbar-collapse navbar-responsive-collapse">
							<ul className="nav navbar-nav">
								{
									menu
								}
							</ul>
						</div>

					</div>
				</nav>

			</header>

			{useMediaQuery("(max-width: 991px)") &&
				<SwipeableDrawer
					variant="temporary"
					anchor="left"
					open={openSN}
					onClose={() => setOpenSN(false)}
					onOpen={() => setOpenSN(true)}

				>
					<div style={{ width: '280px', height: '100%', overflow: 'auto' }}>
						<div style={{ width: '100%', background: '#2a0e72', color: '#fff', padding: '25px', textAlign: 'center' }}>
							<h2>CMP</h2>
							<h3>Santiago de Cuba</h3>
						</div>
						<ul className="nav navbar-nav" style={{ margin: 0 }}>
							{
								sideMenu
							}
						</ul>
					</div>
				</SwipeableDrawer>
			}

		</div>
	)
}

export default Nav;